import {matchContractVariables} from "$lib/utils/templating/contractVariables";
import type {Contract, ContractHistory, Employee} from "$lib/types/employee";
import {allUnits} from "$lib/stores/unit";
import {tariffs} from "$lib/stores/tariffs";
import wordDocumentParser from "$lib/utils/templating/wordDocumentParser";
import {PUBLIC_API_PATH} from "$env/static/public";
import {templateDocuments} from "$lib/stores/templateDocuments";
import Sleep from "$lib/utils/sleep";

let units : any[] = [];
let localTariffs : any[] = [];
let localTemplates: any[] = [];
allUnits.subscribe(x => units = x)
tariffs.subscribe(x => localTariffs = x)

templateDocuments.subscribe(x => localTemplates = x)

export default async function generateContractPreview(employee: Employee, contract: Contract, contractHistory: ContractHistory, customVariables: any): Promise<Blob | null> {
    await Sleep(100)
    const documentTemplateId = localTemplates.find(x => x.contractType === contract?.contractType)?.id
    return await parsePreview(employee, contract, contractHistory, customVariables, documentTemplateId)
}

export const generateContractModification = async (employee: Employee, contract: Contract, contractHistory: ContractHistory, documentTemplateType: string, customVariables: any) => {
    await Sleep(100)
    const documentTemplateId = localTemplates.find(x => x.contractType === documentTemplateType)?.id
    return await parsePreview(employee, contract, contractHistory, customVariables, documentTemplateId)
}

const parsePreview = async (employee: Employee, contract: Contract, contractHistory: ContractHistory, customVariables: any, documentTemplateId: string) => {
    const variables = matchContractVariables({
            ...employee,
            unit: units.find((u: any) => u.id === employee.unitId)},
        contract,
        contractHistory,
        localTariffs,
        customVariables);
    return await wordDocumentParser(PUBLIC_API_PATH + '/template-document/'+documentTemplateId + '/binary', variables)
}